module.exports = __webpack_public_path__ + "img/agents_icon.d7bbe44a.svg";